export default "__VITE_ASSET__CLwXXX8j__"